import { render } from "./JapanidxTrend.vue?vue&type=template&id=020f7e7c&scoped=true"
import script from "./JapanidxTrend.vue?vue&type=script&lang=js"
export * from "./JapanidxTrend.vue?vue&type=script&lang=js"

import "./JapanidxTrend.vue?vue&type=style&index=0&id=020f7e7c&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020f7e7c"]])

export default __exports__